'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowLeft, faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useClickAway, useWindowSize } from 'react-use';
import { ChevronRightIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { Swipeable } from '../⚛\uFE0Fatoms/Swipeable';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {useTranslation} from "react-i18next";

export function ToolDrawer({ children, open, setOpen, title, setCurrentToolDrawer }) {
  const location = useLocation();
  const [inV2, setInV2] = useState(false);
  const { width } = useWindowSize();
  const toggle = () => setOpen(!open);
  const [showNav, setShowNav] = useState(false);
  const navRef = useRef(null);
  useClickAway(navRef, () => setShowNav(false));
  const { t } = useTranslation();

  useEffect(() => {
    if (location.pathname.includes('v2')) {
      setInV2(true);
    } else {
      setInV2(false);
    }
  }, [location]);

  function handleClose() {
    setOpen(false);
  }

  return (
    <>
      {width < 900 && open && <div className="fixed z-50 h-screen w-screen backdrop-blur-sm"></div>}
      <div
        data-open={open}
        className={`fixed -bottom-[88.8dvh] z-50 ml-[3%] h-[90dvh] w-[94%] rounded-xl shadow-md ring-1 ring-gray-200 transition-all duration-500 data-[open=true]:bottom-0 lg:top-[9.1dvh] lg:-right-[27.4%] lg:w-[28%] lg:data-[open=true]:right-12`}
      >
        <div
          className="joyride-tooldraweropen absolute -top-17 left-1/2 flex -translate-x-1/2 rounded-t-3xl p-5 transition-all hover:cursor-pointer lg:top-5 lg:-left-35 lg:translate-x-0 lg:rounded-3xl"
          onClick={() => {
            toggle();
          }}
          data-open={open}
        >
          {width > 736 ? (
            <>
              {!open && (
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="relative flex gap-3 rounded-md text-gray-400 hover:cursor-pointer hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                >
                  <div className="text-pddarkblue text-right text-lg leading-7 uppercase">{t('Open')}</div>
                  <FontAwesomeIcon icon={faCircleArrowLeft} className="text-pddarkblue rotate-90 lg:rotate-none" />
                </button>
              )}
            </>
          ) : (
            <>
              {!open && (
                <>
                  <ChevronUpIcon className="size-10 data-[open=true]:rotate-180" data-open={open} />
                  <span className="pl-4">{t("Open")}</span>
                </>
              )}
            </>
          )}
        </div>
        <Swipeable className="h-full w-full" onSwipeDown={handleClose}>
          <div className="border-pddarkblue/20 relative flex h-1/12 w-full items-center justify-between rounded-t-xl border-b-1 bg-white px-4 py-4">
            {inV2 ? (
              <div className="flex items-center" onClick={() => setShowNav(!showNav)}>
                <ChevronRightIcon className={`size-10 ${showNav && 'rotate-90'} transform-[rotate] duration-200`} />
                <span className="text-3xl leading-loose font-black text-gray-900">{title}</span>
              </div>
            ) : (
              <span className="pl-10 text-3xl leading-loose font-black text-gray-900">{title}</span>
            )}
            {showNav && (
              <div
                ref={navRef}
                className="absolute top-20 left-5 z-20 flex w-1/2 flex-col rounded-xl border-1 border-gray-200 bg-white shadow-md"
              >
                <div
                  className="hover:bg-pdteal/5 w-full border-b-1 border-gray-200 px-5 font-black hover:cursor-pointer"
                  onClick={() => {
                    setCurrentToolDrawer('Notes');
                    setShowNav(false);
                  }}
                >
                  <div className="my-5 text-3xl">{t("Notes")}</div>
                </div>
                <div
                  className="hover:bg-pdteal/5 border-b-1 border-gray-200 px-5 font-black hover:cursor-pointer"
                  onClick={() => {
                    setCurrentToolDrawer('Videos');
                    setShowNav(false);
                  }}
                >
                  <div className="py-5 text-3xl">{t("Videos")}</div>
                </div>
                <div
                  className="hover:bg-pdteal/5 px-5 font-black hover:cursor-pointer"
                  onClick={() => {
                    setCurrentToolDrawer('Highlights');
                    setShowNav(false);
                  }}
                >
                  <div className="my-5 text-3xl">{t("Highlights")}</div>
                </div>
                {/*<div*/}
                {/*  className="hover:bg-pdteal/5 px-5 font-black hover:cursor-pointer"*/}
                {/*  onClick={() => {*/}
                {/*    setCurrentToolDrawer('Tools');*/}
                {/*    setShowNav(false);*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <div className="my-5 text-3xl">Tools</div>*/}
                {/*</div>*/}
              </div>
            )}
            <button
              type="button"
              onClick={() => {
                handleClose();
              }}
              className="joyride-tooldrawerclose relative flex gap-3 rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
            >
              <div className="text-pddarkblue text-right text-lg leading-7 uppercase">{t("Collapse")}</div>
              <FontAwesomeIcon icon={faCircleArrowRight} className="text-pddarkblue rotate-90 lg:rotate-none" />
            </button>
          </div>
          <div className="relative flex h-11/12 flex-1 flex-col justify-between overflow-hidden bg-white px-4 sm:rounded-none sm:px-6 lg:rounded-b-xl">
            {children}
          </div>
        </Swipeable>
      </div>
    </>
  );
}
